<template>
  <div>
    <!-- 表格 -->
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <Table
        :columns="tableCols"
        :data="data2"
        :table="table"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
      >
      </Table>
    </Row>
    <Form
      ref="formDynamic"
      :model="formDynamic"
      :label-width="80"
      style="width: 900px; margin-top: 30px"
    >
      <FormItem>
        <Button type="primary" @click="handleSubmit()">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  props: {
    consumableInventory: [],
  },
  data() {
    return {
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      index: 1,
      desk: "",
      receive: "",
      main: "",
      deskList: [],
      data2: [],
      deskId: "",
      tableCols: [
        {
          title: "货物信息",
          width: 530,
          align: "center",
          render: (h, p) => {
            return h("div", [
              h("img", {
                style: {
                  width: "60px",
                  height: "60px",
                  float: "left",
                  margin: "10px",
                  display: "block",
                },
                attrs: { src: p.row.consumableImgUrl },
              }),
              h("div", [
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      float: "left",
                      marginTop: "5px",
                      marginLeft: "9px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                    domProps: {
                      title: p.row.brand,
                    },
                  },
                  p.row.brand
                ),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      marginTop: "5px",
                      marginLeft: "5px",
                      float: "left",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                    domProps: {
                      title: p.row.name,
                    },
                  },
                  p.row.name
                ),
              ]),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    marginTop: "5px",
                    width: "80%",
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: "型号:" + p.row.model,
                  },
                },
                "型  号: " + p.row.model
              ),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "80%",
                    textAlign: "left",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: "适用于: " + p.row.remark,
                  },
                },
                "适用于: " + p.row.remark
              ),
            ]);
          },
        },
        {
          title: "库存",
          key: "num",
          minWidth: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.num;
            return h(
              "div",
              {
                style: {
                  color: row.num <= 10 ? "red" : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "领用数量",
          key: "receiveNum",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.receiveNum;
            return h(
              "InputNumber",
              {
                props: {
                  min: 1,
                  max: 100,
                  value: params.row.receiveNum,
                },
                on: {
                  "on-change": (event) => {
                    this.data2[params.index].receiveNum = event;
                  },
                },
                style: {
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              params.row.receiveNum
            );
          },
        },
      ],
    };
  },
  async created() {
    let arr = this.consumableInventory;
    for (let i = 0; i < arr.length; i++) {
      let consumableIn = {};
      consumableIn.inventoryId = arr[i].inventoryId;
      consumableIn.consumableNum = arr[i].consumableNum;
      consumableIn.consumableImgUrl = arr[i].consumableImgUrl;
      consumableIn.brand = arr[i].brand;
      consumableIn.name = arr[i].name;
      consumableIn.model = arr[i].model;
      consumableIn.remark = arr[i].remark;
      consumableIn.num = arr[i].num;
      consumableIn.unit = arr[i].unit;
      consumableIn.receiveNum = arr[i].receiveNum;
      this.data2.push(consumableIn);
    }

    this.checkData();
  },
  methods: {
    async handleSubmit() {
      let consumableList = this.data2;
      let q = {
        consumableList: consumableList,
        deskId: this.deskId,
      };
      let res = await $utils.api.load("/customer/customer/inventory/receive", q, "put");
      if (res.code == 200) {
        await $utils.toast.success("提交成功");
        $utils.url.go(0);
        this.$Modal.remove();
      } else {
        $utils.toast.error(res.message);
      }
    },
    checkData() {
      this.data2 = this.consumableInventory;
    },
    handleRemove(index) {
      this.formDynamic.items[index].status = 0;
    },
  },
};
</script>
